import React, { useEffect } from 'react';
import useTaboola from 'app/components/ads/taboola/useTaboola';
import useEnableTaboolaFeed from 'app/components/ads/taboola/useEnableTaboolaFeed';
const TaboolaFeed = _ref => {
  let {
    config
  } = _ref;
  const [enableTaboolaFeed] = useEnableTaboolaFeed();
  useTaboola(enableTaboolaFeed);
  useEffect(() => {
    window._taboola.push({
      article: 'auto',
      url: window.location.href
    });
    window._taboola.push({
      mode: 'alternating-thumbnails-a',
      container: config.containerId,
      placement: config.placement,
      target_type: 'mix'
    });
  }, [config]);
  return /*#__PURE__*/React.createElement("div", {
    id: config.containerId,
    "data-sentry-component": "TaboolaFeed",
    "data-sentry-source-file": "TaboolaFeed.tsx"
  });
};
export default TaboolaFeed;